import { render, staticRenderFns } from "./WorkShiftEdit.vue?vue&type=template&id=23b359f2&scoped=true&"
import script from "./WorkShiftEdit.vue?vue&type=script&lang=js&"
export * from "./WorkShiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b359f2",
  null
  
)

export default component.exports